import { STORAGE_KEYS as s } from "./storage-manager.js";
import m from "./subscription-manager.js";
import li from "../models/server-config.js";
import v from "../common/event-logger.js";
import { EventTypes as f } from "../../shared-lib/index.js";
import {
  REQUEST_BACKOFF_MAX_SLEEP_MS_DEFAULT as u,
  REQUEST_BACKOFF_MIN_SLEEP_MS_DEFAULT as c,
  REQUEST_BACKOFF_SCALE_FACTOR_DEFAULT as d,
} from "../common/constants.js";
export default class Bt {
  constructor(t) {
    (this.B = t),
      (this.B = t),
      (this.Ec = new m()),
      (this.Bc = new m()),
      (this.wc = new m()),
      (this.Cc = new m()),
      (this.yc = new m()),
      (this.Fc = null),
      (this.Lc = null);
  }
  Mc() {
    if (null == this.Lc) {
      const t = this.B.dt(s.ft.jc);
      this.Lc = null != t ? li._u(t) : new li();
    }
    return this.Lc;
  }
  xt() {
    return this.Mc().kc;
  }
  Sc(t) {
    var i, e, n, r;
    if (null != t && null != t.config) {
      const l = t.config;
      if (l.time > this.Mc().kc) {
        const t = (t) => (null == t ? this.Mc().Nc : t),
          u = new li(
            l.time,
            l.events_blacklist,
            l.attributes_blacklist,
            l.purchases_blacklist,
            l.messaging_session_timeout,
            l.vapid_public_key,
            l.content_cards,
            l.feature_flags,
            t(l.global_request_rate_limit),
            l.banners,
            l.dust,
            l.request_backoff,
          );
        let o = !1;
        null != u.xc && this.ju() !== u.xc && (o = !0);
        let a = !1;
        null != u.Gc.enabled && this.wi() !== u.Gc.enabled && (a = !0);
        let h = !1;
        null != u.Xr.enabled && this.Yr() !== u.Xr.enabled && (h = !0);
        let c = !1;
        null !=
          (null === (i = u.banners) || void 0 === i ? void 0 : i.enabled) &&
          this.kt() !==
            (null === (e = u.banners) || void 0 === e ? void 0 : e.enabled) &&
          (c = !0);
        let d = !1;
        null != (null === (n = u.dust) || void 0 === n ? void 0 : n.enabled) &&
          this.Ye() !==
            (null === (r = u.dust) || void 0 === r ? void 0 : r.enabled) &&
          (d = !0),
          (this.Lc = u),
          this.B.bt(s.ft.jc, u.gt()),
          o && this.Ec.L(),
          a && this.Bc.L(),
          h && this.wc.L(),
          c && this.Cc.L(),
          d && this.yc.L();
      }
    }
  }
  xu(t) {
    const i = this.Ec.Rt(t);
    return this.Fc && this.Ec.removeSubscription(this.Fc), (this.Fc = i), i;
  }
  Ci(t) {
    return this.Bc.Rt(t);
  }
  jo(t) {
    return this.wc.Rt(t);
  }
  P(t) {
    return this.Cc.Rt(t);
  }
  Tr(t) {
    return this.yc.Rt(t);
  }
  Ce(t) {
    return -1 !== this.Mc().Ic.indexOf(t);
  }
  qu(t) {
    return -1 !== this.Mc().Kc.indexOf(t);
  }
  Dr(t) {
    return -1 !== this.Mc().Pc.indexOf(t);
  }
  _c() {
    return this.Mc().Oc;
  }
  ju() {
    return this.Mc().xc;
  }
  wi() {
    return this.Mc().Gc.enabled || !1;
  }
  Vc() {
    const t = this.Mc().Nc;
    return !(!t || null == t.enabled) && t.enabled;
  }
  qc() {
    if (!this.Vc()) return -1;
    const t = this.Mc().Nc;
    return null == t.capacity || t.capacity < 10 ? -1 : t.capacity;
  }
  Ac() {
    if (!this.Vc()) return -1;
    const t = this.Mc().Nc;
    return null == t.refill_rate || t.refill_rate <= 0 ? -1 : t.refill_rate;
  }
  zc(t) {
    const i = this.Mc().Nc.endpoint_overrides;
    return null == i ? null : i[t];
  }
  Dc(t) {
    const i = this.zc(t);
    return null == i || isNaN(i.capacity) || i.capacity <= 0 ? -1 : i.capacity;
  }
  Tc(t) {
    const i = this.zc(t);
    return null == i || isNaN(i.refill_rate) || i.refill_rate <= 0
      ? -1
      : i.refill_rate;
  }
  Yr() {
    return this.Mc().Xr.enabled && null == this.yo()
      ? (v.lt(f.wl, { e: "Missing feature flag refresh_rate_limit." }), !1)
      : this.Mc().Xr.enabled || !1;
  }
  yo() {
    return this.Mc().Xr.refresh_rate_limit;
  }
  kt() {
    var t;
    return (
      (null === (t = this.Mc().banners) || void 0 === t ? void 0 : t.enabled) ||
      null
    );
  }
  oe() {
    var t;
    return (
      (null === (t = this.Mc().banners) || void 0 === t
        ? void 0
        : t.max_placements) || 0
    );
  }
  Ye() {
    var t;
    return (
      (null === (t = this.Mc().dust) || void 0 === t ? void 0 : t.enabled) || !1
    );
  }
  st() {
    var t;
    const i =
      null === (t = this.Mc().Hc) || void 0 === t
        ? void 0
        : t.min_sleep_duration_ms;
    return null != i ? i : c;
  }
  it() {
    var t;
    const i =
      null === (t = this.Mc().Hc) || void 0 === t ? void 0 : t.scale_factor;
    return null != i ? i : d;
  }
  nt() {
    var t;
    const i =
      null === (t = this.Mc().Hc) || void 0 === t
        ? void 0
        : t.max_sleep_duration_ms;
    return null != i ? i : u;
  }
}
